module.exports = __webpack_public_path__ + "static/swoof-og-2803082b43085e167fa9afc5edf05dc9.png";